import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAppIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 28,
	height: 19,
	viewBox: "0 0 28 19",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1.58096 14.7523C0.764345 15.8748 -0.687336 17.4424 0.374134 18.2943C1.49601 16.9956 3.2506 15.8146 5.2799 14.8109C12.6479 11.1668 15.464 13.8117 16.1572 8.52897C17.4294 7.63171 22.4686 5.89108 20.4148 10.6832C18.361 15.4753 14.3542 18.2942 14.3542 18.2942C14.3542 18.2942 26.4754 12.0085 26.8983 16.2586C27.5234 14.3164 28.1773 10.77 27.6683 8.31164C26.1032 0.75228 18.5828 -0.330774 15.0182 0.0726179C7.02934 2.16229 7.41346 6.63314 7.43279 8.35797C6.71554 9.5587 5.98392 11.069 5.06155 12.0085C4.24824 12.8369 3.82019 13.134 1.58096 14.7523Z",
		fill: "#BB5C3A"
	})
});
export default SvgAppIcon;
